import * as React from 'react';
import CancerQuestion from './medicalQuestions/medicalQuestion1/CancerQuestion';
import HeartAndCirculatoryQuestion from './medicalQuestions/medicalQuestion1/HeartAndCirculatoryQuestion';
import NeurologicalQuestion from './medicalQuestions/medicalQuestion1/NeurologicalQuestion';
import RespiratoryQuestion from './medicalQuestions/medicalQuestion1/RespiratoryQuestion';
import LiverQuestion from './medicalQuestions/medicalQuestion1/LiverQuestion';
import BloodQuestion from './medicalQuestions/medicalQuestion1/BloodQuestion';
import ImmunologicalQuestion from './medicalQuestions/medicalQuestion1/ImmunologicalQuestion';
import HeadQuestion from './medicalQuestions/medicalQuestion1/HeadQuestion';
import ReproductiveQuestion from './medicalQuestions/medicalQuestion2/ReproductiveQuestion';
import PsychologicalQuestion from './medicalQuestions/medicalQuestion2/PsychologicalQuestion';
import MedicalQuestion3 from './medicalQuestions/medicalQuestion3/MedicalQuestion3';
import PainkillerQuestion from './medicalQuestions/medicalQuestion3/PainkillerQuestion';
import FamilyHistory from './medicalQuestions/medicalQuestion5/FamilyHistory';
import WorkflowStep from '../../WorkflowStep';
import Fieldset from '../../../components/forms/Fieldset';

interface Props {
	user: UserDetails;
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;
	parentNext: (e: any) => void;
	parentPrev: (e: any) => void;
	className?: string;
}
interface State {
	currentStep: number;
}
class MedicalHistoryForm extends React.Component<Props, State> {
	lastStep = 12;
	constructor(props: Props) {
		super(props);
		this.state = {
			currentStep: this.getStep()
		};
	}
	getStep() {
		var step = parseInt(location.hash.replace('#', ''), 10);
		if (!isNaN(step)) {
			return step;
		}
		return 0;
	}
	componentDidUpdate(prevProps: Props, prevState: State) {
		if (this.state.currentStep !== prevState.currentStep) {
			location.hash = this.state.currentStep.toString();
		}
	}
	prevStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep <= 0) {
			this.props.parentPrev(e);
			return;
		} else {
			currentStep--;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}

	nextStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep === this.lastStep) {
			this.props.parentNext(e);
			return;
		} else {
			currentStep++;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}

	render() {
		const { questions, questionnaire, onQuestionnaireBlur, onQuestionnaireChange } = this.props;
		const gender = this.props.user.gender;
		let currentQuestion = null;
		const questionParameters = {
			questions: questions,
			questionnaire: questionnaire,
			onQuestionnaireBlur: onQuestionnaireBlur,
			onQuestionnaireChange: onQuestionnaireChange,
			nextStep: this.nextStep,
			prevStep: this.prevStep
		};
		switch (this.state.currentStep) {
			case 0:
				currentQuestion = (<CancerQuestion {...questionParameters} />);
				break;
			case 1:
				currentQuestion = (<HeartAndCirculatoryQuestion	{...questionParameters} />);
				break;
			case 2:
				currentQuestion = (<NeurologicalQuestion	{...questionParameters} />);
				break;
			case 3:
				currentQuestion = (<RespiratoryQuestion	{...questionParameters} />);
				break;
			case 4:
				currentQuestion = (<LiverQuestion	{...questionParameters} />);
				break;
			case 5:
				currentQuestion = (<BloodQuestion	{...questionParameters} />);
				break;
			case 6:
				currentQuestion = (<ImmunologicalQuestion	{...questionParameters} />);
				break;
			case 7:
				currentQuestion = (<HeadQuestion	{...questionParameters} />);
				break;
			case 8:
				currentQuestion = (<ReproductiveQuestion gender={gender} {...questionParameters} />);
				break;
			case 9:
				currentQuestion = (<PsychologicalQuestion	{...questionParameters} />);
				break;
			case 10:
				currentQuestion = (<MedicalQuestion3 gender={gender} {...questionParameters} />);
				break;
			case 11:
				currentQuestion = (<PainkillerQuestion	{...questionParameters} />);
				break;
			case 12:
			default:
				currentQuestion = (<FamilyHistory	{...questionParameters} />);
				break;
		}
		return (
			<WorkflowStep
				className={this.props.className}
				title={this.state.currentStep === 0 ? 'Finally, we\'d like to ask a few questions about your medical history.' : ''}
			>
				<Fieldset>
					{currentQuestion}
				</Fieldset>
			</WorkflowStep>
		);
	}
}

export default MedicalHistoryForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/MedicalHistoryForm.tsx